/**
 * Show Preloader
 */

export const showPreloader = () => {
  const preloader = document.getElementById("preloader");
  if (preloader) {
    preloader.classList.add("d-flex");
    preloader.classList.remove("d-none");
  }
};

/**
 * Hide Preloader
 */

export const hidePreloader = () => {
  const preloader = document.getElementById("preloader");
  if (preloader) {
    preloader.classList.add("d-none");
    preloader.classList.remove("d-flex");
  }
};

/**
 * Clear Data
 */

export const clearData = () => {
  const archiveLoopSection = document.getElementById("archive-loop-section");
  const products = archiveLoopSection.children;
  Array.from(products).forEach((product) => {
    product.remove();
  });
};
